import React, { FC } from "react";
import { useTranslations } from "next-intl";
import classNames from "classnames";

import { CustomRadioButton, ShowWhen } from "@/components/common";
import { Country, Theme, TransportationType } from "@/enums";
import { TDeliveryTypeItemProps } from "../types";
import { useTheme } from "@/context/Theme.context";
import { formatNumber } from "@/utils/formatNumber";

const getDeliveryPrice = (
  type: TransportationType,
  currentPrice: any,
  theme: Theme | "",
  selectedCountryId: number,
) => {
  if (theme === Theme.UZ && selectedCountryId === Country.CHINA_LAND) {
    return currentPrice?.seaPriceNational / 10;
  }
  if (theme === Theme.GEORGIA && selectedCountryId === Country.CHINA_LAND) {
    return currentPrice?.airPriceUsd;
  }
  if (theme === Theme.GEORGIA && selectedCountryId === Country.TURKEY) {
    return currentPrice?.airPriceUsd;
  }
  if (type === TransportationType.AIR) {
    return theme === Theme.UZ
      ? currentPrice?.airPriceNational / 10
      : currentPrice?.airPriceUsd;
  }
  if (type === TransportationType.GROUND) {
    return theme === Theme.UZ
      ? currentPrice?.groundPriceNational
      : currentPrice?.groundPriceUsd;
  }
  if (type === TransportationType.SEA) {
    return theme === Theme.UZ
      ? currentPrice?.seaPriceNational / 10
      : currentPrice?.seaPriceUsd;
  }
  if (type === TransportationType.ECONOMY) {
    return currentPrice?.seaPriceEconomyUsd;
  }
  return "0";
};

const DeliveryTypeItem: FC<TDeliveryTypeItemProps> = ({
  item: { id, name, deliveryTime, icon: Icon, priceLabel },
  isActive,
  handleClick,
  isSendParcel,
  deliveryPrice,
  fromCountry,
  type,
  selectedCountryId,
  isAddParcel = false,
  disabled = false,
  style,
}) => {
  const t = useTranslations();
  const theme = useTheme();

  const currentPrice = deliveryPrice?.fromCountryId[fromCountry];

  const price = getDeliveryPrice(type, currentPrice, theme, selectedCountryId);

  return (
    <div
      className={classNames("w-full rounded-[35px] border-2 p-2 pr-4", {
        "border-[#CBF3BA]": isActive,
        "max-w-[308px]": isSendParcel,
        "cursor-not-allowed opacity-50": disabled,
        "cursor-pointer": !disabled,
      })}
      onClick={() => !disabled && handleClick(id)}
      style={style}
    >
      <div className="flex items-center justify-between gap-2">
        <div
          className={classNames(
            "flex h-[2.87rem] w-[2.87rem] items-center justify-center rounded-full p-3",
            {
              "bg-[#EFFBE9]": isActive,
              "bg-[#F9F9F9]": !isActive,
            },
          )}
        >
          <Icon className={classNames({ "fill-[#5dd826]": isActive })} />
        </div>
        <div>
          <p className="text-sm font-semibold text-black">
            {priceLabel
              ? `${t(name)} - ${t(priceLabel)}`
              : `${t(name)} - ${theme === Theme.UZ ? "UZS" : "$"} ${formatNumber(price || 0)}${theme === Theme.UZ ? " / 100 " + t("gr") : ""}`}
          </p>
          <ShowWhen condition={!isAddParcel}>
            <p className="text-xs text-[#9d9d9d]">{t(deliveryTime)}</p>
          </ShowWhen>
        </div>
        <CustomRadioButton
          id="1"
          selected={isActive}
          onChange={() => {}}
          className="shrink-0"
        />
      </div>
    </div>
  );
};

export { DeliveryTypeItem };
